import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Grid, Form, Dropdown, Checkbox } from "semantic-ui-react";
import { server } from "../../App";
import { columnDefs, topOptions, bottomOptions } from "./GridParams/GridParams";
import { useWindowSize } from "react-use";
import { useSelector, useDispatch } from "react-redux";
import {
  selectPriseEnChargeGrid,
  PriseEnChargeDATAllRows,
  PriseEnChargeYear,
  GlobalCheckBoxValideEnCours,
  GlobalSelectMedecin,
  GlobalSelectClinique
} from "../../features/PriseEnCharge/PriseEnChargeSlice";

import {
  YearsOptions,
} from "../Consultation/bloc3/DropdownOptions/AvOptions";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"

function ActPatientGrid(props) {

  const data = useGetDoctorsSemanticUI()

  // const { date } = props;

  const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);
  // APP state
  const dispatch = useDispatch();

  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("87vh");

  // const [Year, setYear] = useState(moment().format("YYYY"));
  // const [Month, setMonth] = useState(moment().format("MM"));

  const {
    GlobalYear,
    FK_id_medecin2,
    priseEnChargeDataAllRows,
    GlobalCheckBoxValEnCo,
    priseEnChargeClinique
  } = PriseEnChargeState;

  // const Type_clinic = useQuery("GetALLCLINICS", () =>
  //   GetALLCLINICS()
  // );
  // let allclinics = Type_clinic?.data?.map((item, index) => (
  //   { key: item.idclinique, text: item.NomClinique, value: item.idclinique }
  // ))

  let myObject = { key: "0000000A", text: "Al Forat", value: 3 }

  let allclinics = []

  allclinics.push(myObject)

  const GetAllPrise_en_ChargesEnCours = async () => {
    // console.log("data", data);
    let url;

    if (GlobalCheckBoxValEnCo === 0) {
      url = `${server}PriseEnCharge/GetAllPrise_en_ChargesEnCours/${FK_id_medecin2}/${priseEnChargeClinique}`;
    } else {
      url = `${server}PriseEnCharge/Year/${GlobalYear}/${FK_id_medecin2}/${priseEnChargeClinique}`;
    }

    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(PriseEnChargeDATAllRows(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetAllPrise_en_ChargesEnCours();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    GetAllPrise_en_ChargesEnCours();
  }, [GlobalYear, GlobalCheckBoxValEnCo, FK_id_medecin2, priseEnChargeClinique]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    // gridApi?.resetRowHeights();
  };

  topOptions.alignedGrids.push(bottomOptions);
  // bottomOptions.alignedGrids.push(topOptions);







  function name(height, width) {
    if (height <= 702 && height >= 600 && width >= 1260 && width <= 1366) {
      setNewHeightValue("82vh");
    } else {
      setNewHeightValue("87.5vh");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  return (
    <>
      <Grid columns="equal" centered className="fixWidth2">
        <Grid.Row className="emptyPadding emptyPadding2">
          <Form.Field
            // className="TinySelect"
            value={priseEnChargeClinique}
            search
            selection
            fluid
            // label="Clinique"
            control={Dropdown}
            options={allclinics ? allclinics : []}
            placeholder="Select clinic"
            onChange={(e, data) => {
              dispatch(GlobalSelectClinique(data.value));
            }}
          />
          <Form.Field
            className="TinySelect"
            value={GlobalYear}
            search
            selection
            fluid
            // label="Année"
            control={Dropdown}
            options={YearsOptions}
            placeholder="Année"
            onChange={(e, data) => {
              dispatch(PriseEnChargeYear(data.value));
            }}
          />
          <Form.Field className="checkboxPriseEnCharge">
            <Checkbox
              toggle
              label={` Validé en ${GlobalYear}`}
              name="checkboxRadioGroup"
              value={1}
              checked={GlobalCheckBoxValEnCo === 1}
              onChange={(e, data) =>
                dispatch(GlobalCheckBoxValideEnCours(data.value))
              }
            />
          </Form.Field>

          {/* </Grid.Column> */}
        </Grid.Row>
        <Grid.Row className="emptyPadding">
          <Form.Field
            className="SomeMargin"
            value={FK_id_medecin2}
            search
            selection
            fluid
            // label="Année"
            control={Dropdown}
            options={data?.Doctors_list ? data?.Doctors_list : []}
            // placeholder="Select Doctor"
            onChange={(e, data) => {
              dispatch(GlobalSelectMedecin(data.value));
            }}
          />
          <Form.Field className="checkboxEncours">
            <Checkbox
              toggle
              label="En cours"
              name="checkboxRadioGroup"
              value={0}
              checked={GlobalCheckBoxValEnCo === 0}
              onChange={(e, data) =>
                dispatch(GlobalCheckBoxValideEnCours(data.value))
              }
            />
          </Form.Field>


        </Grid.Row>

      </Grid>
      <div
        id="myGrid"
        className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          width: "100%",
          flex: "1 1 auto",
        }}
      >
        <AgGridReact
          rowData={priseEnChargeDataAllRows}
          animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          columnDefs={columnDefs}
          // defaultColDef={defaultColDef}
          rowSelection={"single"}
          // onSelectionChanged={onSelectionChanged}
          gridOptions={topOptions}
        // onRowDoubleClicked={onRowDoubleClicked}
        // onFirstDataRendered={onFirstDataRendered}
        ></AgGridReact>
        {/* <br></br>
        <br></br>
        <br></br>
        <br></br> */}
      </div>
      {/* <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} /> */}
    </>
  );
}

export default ActPatientGrid;
